import React from 'react';
import { Separator } from "../ui/separator.jsx";
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Badge } from "../ui/badge.jsx";
import { AlertCircle, Clock, CheckCircle, Activity } from 'lucide-react';

export default function TicketTimeline({ tickets, isLoading }) {
  const priorityColors = {
    low: 'bg-blue-100 text-blue-800',
    medium: 'bg-yellow-100 text-yellow-800',
    high: 'bg-orange-100 text-orange-800',
    critical: 'bg-red-100 text-red-800'
  };
  
  const statusIcons = {
    open: <AlertCircle className="h-5 w-5 text-blue-500" />,
    in_progress: <Activity className="h-5 w-5 text-yellow-500" />,
    resolved: <CheckCircle className="h-5 w-5 text-green-500" />,
    closed: <CheckCircle className="h-5 w-5 text-gray-500" />,
    analysis: <Clock className="h-5 w-5 text-purple-500" />,
    reopened: <AlertCircle className="h-5 w-5 text-red-500" />
  };
  
  const statusLabels = {
    open: 'Aberto',
    in_progress: 'Em Progresso',
    resolved: 'Resolvido',
    closed: 'Fechado',
    analysis: 'Em Análise',
    reopened: 'Reaberto'
  };
  
  // Ordenar tickets por data de criação (mais recentes primeiro)
  const sortedTickets = tickets && tickets.length 
    ? [...tickets].sort((a, b) => new Date(b.created_date) - new Date(a.created_date))
    : [];
  
  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((_, i) => (
          <div key={i} className="flex gap-3 animate-pulse">
            <div className="mt-1 h-8 w-8 rounded-full bg-gray-200"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-100 rounded"></div>
              <div className="flex gap-2">
                <div className="h-6 w-16 bg-gray-100 rounded-full"></div>
                <div className="h-6 w-16 bg-gray-100 rounded-full"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  
  if (!sortedTickets.length) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <AlertCircle className="h-10 w-10 mx-auto mb-3 opacity-20" />
        <p>Nenhum chamado registrado.</p>
      </div>
    );
  }
  
  return (
    <div className="space-y-4">
      {sortedTickets.slice(0, 5).map((ticket, index) => (
        <div key={ticket.id || index}>
          <div className="flex items-start gap-3">
            <div className="mt-1">
              {statusIcons[ticket.status] || <AlertCircle className="h-5 w-5 text-gray-400" />}
            </div>
            <div className="flex-1">
              <p className="font-medium">{ticket.title}</p>
              <p className="text-sm text-muted-foreground">
                {format(new Date(ticket.created_date), "dd 'de' MMMM", { locale: ptBR })}
              </p>
              <div className="flex flex-wrap gap-2 mt-1">
                <Badge 
                  variant="secondary"
                  className={priorityColors[ticket.priority] || 'bg-gray-100 text-gray-800'}
                >
                  {ticket.priority}
                </Badge>
                <Badge variant="outline">
                  {statusLabels[ticket.status] || ticket.status}
                </Badge>
              </div>
            </div>
          </div>
          {index < sortedTickets.slice(0, 5).length - 1 && <Separator className="my-3" />}
        </div>
      ))}
    </div>
  );
}